<template>

    <!--seccion inputs-->
    <div class="row mt-4">
        <div class="col-lg-3 col-md-12 col-xs-12 mb-3">
            <div class="c-search__search-wrapper">
                <input type="search" placeholder="Universidad, barrio, metro…" class="form-control c-search__search-input" autocomplete="off" >
            </div>
        </div>
        <div class="col-lg-3 col-md-12 col-xs-12 mb-3">
            <div class="c-search__search-wrapper-date">
                <input type="text" placeholder="Seleccionar fechas" class="form-control c-search__search-date-input">
            </div>  
        </div>
        <div class="col-lg-2 col-md-12 col-xs-12 mb-3">
            <a href="#" class="btn btn-default btn-filter">
				<font-awesome-icon :style="{ color: '#5A287F' }" size="1x" :icon="['fa', 'star']" /> Filtrar
			</a>
        </div>
        <div class="col-lg-2 col-md-12 col-xs-6 mb-1">
            <button  class="btn btn-default btn-search"><img width="20px;" src="../assets/magnifying-glass.svg"></button>
        </div>
        <div class="col-lg-2 col-md-12 col-xs-12 mb-3">
            <div class="content-select">
                <select  class="btn-custom ind-0">
                    <option disabled selected>$CLP</option>
                    <option class="black">Option 2</option>
                    <option class="black">Option 3</option>
                </select>
                <i></i>
            </div>
        </div>
        <hr class="custom-100 mt-2">
    </div>
    <!--fin seccion inputs-->



</template>

<script>
export default {
  name: 'Controls2'
}
</script>


<style scoped>

    .c-search__search-wrapper:before {
        content: url('../assets/pin.svg');
        position: absolute;
        left: calc(0.75rem * 2 );
        transform: scale(.5);
    }

    .c-search__search-input {
        text-indent: 30px;
        height: 39px; 
        border: 0;
        border-radius: 0;
        font-size: 1em;
    }


    .c-search__search-wrapper-date:before {
        content: url('../assets/noun_Calendar_1581261.svg');
        position: absolute;
        left: calc(0.75rem * 2 );
        transform: scale(.7);
    }

    .c-search__search-date-input {
        text-indent: 30px;
        height: 39px; 
        border: 0;
        border-radius: 0;
        font-size: 1em;;
    }

</style>
